export enum Inclusivity {
    INCLUSIVE, EXCLUSIVE
}
